<h1 mat-dialog-title>{{ titleKey | transloco }}</h1>

<div mat-dialog-content>
  <p>{{ descriptionKey | transloco }}</p>

  <div mat-dialog-actions>
    <button mat-flat-button data-testid="cancel" [mat-dialog-close]="{action: 'cancel'}">{{ cancelKey | transloco }}</button>
    <button mat-flat-button color="primary" data-testid="save" [mat-dialog-close]="{action: 'end'}">{{ actionBtnKey | transloco }}</button>
  </div>
</div>
